import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';
const MyConsignorMaster = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [cities, setcities] = useState([])
    const [isloading, setisloading] = useState(true)
    useEffect(() => {
        if (props.dataId) {
            let locations = ReadAxios({ url: `consignorMaster/${props.dataId}` }) || [];
            locations.then((res) => {
                setcities(res)
                setisloading(false)
            })
        } else {
            setisloading(false)
        }
    }, [])

    let cityNames = []
    if (cities.length > 0) {
        cities.map((object, index) => {
            let temp = {}
            temp.key = object.consignorId
            temp.text = `${object.consignorName} (${object.consignorCode})`
            temp.value = object.consignorCode
            temp.extra = object
            return cityNames[index] = temp
        })
    }
    let handleChange = (data) => {
        setFieldValue(name, data.value)
        let values = data.value
        let id = data.options.find((args) => args.value === values).key
        let extra = data.options.find((args) => args.value === values).extra
        setFieldValue(props.id, id)
        setFieldValue(props.address, extra.address !== null ? extra.address : '')
        setFieldValue(props.nameValue, extra.consignorName)
        setFieldValue(props.code, extra.consignorCode)
        setFieldValue(props.cityName, extra.cityName !== null ? extra.cityName : '')
        setFieldValue(props.cityId, extra.cityId !== null ? extra.cityId : '')
        setFieldValue(props.phone, extra.phone !== null ? extra.phone : '')
        setFieldValue(props.pincode, extra.pincode !== null ? extra.pincode : '')
        setFieldValue(props.gstNumber, extra.gstNumber !== null ? extra.gstNumber : '')
    }
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setisloading(true)
            let searchTerm = data.searchQuery
            ReadAxios({ url: 'consignorMaster', readItems: { searchTerm: searchTerm } })
                .then((result) => {
                    console.log(result);
                    setcities(result.data.resultSet)
                    setisloading(false)
                })
        }
    }
    return (
        <Dropdown
            selection
            search
            loading={isloading}
            style={{ width: "100%" }}
            onSearchChange={handleSearch}
            onChange={(value, data) => handleChange(data)}
            options={cityNames}
            {...props}
        />

    )
}

export default MyConsignorMaster